import type { ReactNode } from "react";

// The chrome's shared glyphs, built from char codes so this source stays
// ASCII; new code takes them from here.
export const SEP = " " + String.fromCharCode(183) + " ";
export const ARROW = String.fromCharCode(8594);
export const MAIL = String.fromCharCode(9993);
export const EMPTY = String.fromCharCode(8212);

/** Renders the present parts of a subtitle joined by sep - never leading. */
export function SepList({ parts, sep = SEP }: { parts: ReactNode[]; sep?: string }) {
  return (
    <>
      {parts.map((part, i) => (
        <span key={i}>
          {i > 0 ? sep : ""}
          {part}
        </span>
      ))}
    </>
  );
}
